<template>
    <div class="login-background">
        <div>
            <div class="row">
                <div class="col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3">
                    <div class="loginForm">
                        <!-- path on server side-->
                        <!--<img src="/logo/AlarmBot_Logo-outline.svg" :title="getTranslation('app_title')"> -->
                        <img src="/static/logo/AlarmBot_Logo-outline.svg" :title="getTranslation('app_title')">
                        <!--<h3 class="login-txt loginElement">-->
                            <!--<span class="fa fa-bell-o"></span>-->
                            <!--{{ getTranslation('app_title') }}-->
                        <!--</h3>-->
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3">
                    <div class="loginForm">
                        <alert-warning :show="showAlertWarning" :label="lblLoginFailed"
                                       :btnClose="true" @closeAlertWarning="closeAlertWarning()"></alert-warning>
                        <alert-no-input :show="showFormWarning" :label="getTranslation('warning_lbl_all_required')"
                                        :btnClose="true" @closeAlertWarning="closeAlertNoInput()"></alert-no-input>
                        <div class="well">
                            <h3>
                                {{ getTranslation('lbl_login_headline') }}
                            </h3>
                            <div class="divider"></div>
                            <form @submit.prevent="login" >
                                <div class="form-group">
                                    <label for="email">{{ getTranslation('lbl_login_email_or_username') }}</label>
                                    <input
                                            type="text"
                                            id="email"
                                            class="form-control"
                                            formControlName="email"
                                            v-model="user.email">
                                </div>
                                <div class="form-group">
                                    <label for="password">{{ getTranslation('lbl_password') }}</label>
                                    <input
                                            type="password"
                                            id="password"
                                            class="form-control"
                                            autocomplete="new-password"
                                            formControlName="password"
                                            v-model="user.password">
                                </div>

                                <!-- change password -  -->
                                <div v-if="!user.passValid">
                                    <div>{{ getTranslation('lbl_v4_passwords_strength_err_description') }}</div>
                                    <div class="form-group">
                                        <label for="psw_set_1">{{ getTranslation('frm_lbl_new_password_1') }}</label>
                                        <input
                                                type="password"
                                                id="psw_set_1"
                                                class="form-control"
                                                formControlName="psw_set_1"
                                                v-model="user.passwordNew1">
                                    </div>
                                    <div class="form-group">
                                        <label for="psw_set_2">{{ getTranslation('frm_lbl_new_password_2') }}</label>
                                        <input
                                                type="password"
                                                id="psw_set_2"
                                                class="form-control"
                                                formControlName="psw_set_2"
                                                v-model="user.passwordNew2">
                                    </div>
                                </div>

                                <div class="divider"></div>
                                <button
                                        class="btn btn-primary"
                                        type="submit"
                                        >{{ getTranslation('app_lbl_action_login') }}</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import { translationMixin } from '../../../../Banet/mixins/translationMixin';
    import ToastAlert from '../../../../Banet/errorsAndNotifications/ToastAlert.vue';
    import { alertMixin } from '../../../../Banet/mixins/alertMixin';
    import BanetWarning from '../../../../Banet/errorsAndNotifications/BanetWarning.vue';
    import { dropdownMixin } from '../../../../Banet/mixins/dropdownMixin.js';
    import { mixin as clickaway } from 'vue-clickaway';
    import { mainEventBus } from '../../../../main';

    export default {
        name: 'Login',
        mixins: [ translationMixin, alertMixin, dropdownMixin, clickaway],
        components: {
            toastAlert: ToastAlert,
            alertWarning: BanetWarning,
            alertNoInput: BanetWarning
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                if (vm.$store.getters.isLogged) {
                    next('/');
                }
            });
        },
        created: function(){
           //this.$store.dispatch('removeLogged');
//           console.log('LOGGED', this.$store.getters.isLogged);
//            if( this.$store.getters.isLogged ) {
//                this.$store.dispatch('logOut');
////               this.$router.push('/register');
//            }
        },
        data: function(){
            return {
                showAlert: false,
                alertData: {},
                user: {
                    passValid: true,
                    passwordNew1: '',
                    passwordNew2: ''
                },
                userData: {},
                showFormWarning: false,
                lblLoginFailed: '',
            };
        },
        sockets:{
           translationsTest: function(msg){
//              alert(msg.msg);
           }
        },
        methods: {
            gotoRegister: function(){
                this.$router.push('/register');
            },
            login: function(){
                this.$store.dispatch('unsetErrors');
                this.closeAlertNoInput();
                this.closeAlertWarning();
                if(!this.user.email || !this.user.password){
                    this.showFormWarning = true;
                    return false;
                }
                const body = JSON.stringify(this.user);
                const headers = new Headers({'Content-Type': 'application/json'});
                this.$http.post('user/signin', body,  {headers: headers})
                    .then (res => {
                        let user = res.body;
                        const roles = this.$store.getters.getRoles.roles;
                        if(roles.indexOf(user.role) === -1){
                           this.alertData = {
                              type: 'warning',
                              msg: 'lbl_no_permission'
                           };
                           mainEventBus.$emit('alert', this.alertData);
                           this.$store.dispatch('logOut');
                           return false;
                        }
                        let userData = {
                          "_id": user._id,
                          "firstName": user.firstName,
                          "lastName": user.lastName,
                          "email": user.email,
                          "role": user.role,
                          "language": user.language,
                          "token": user.token,
                          "authTokenExpiration": Date.now() + 7200000
                        };
                        this.$store.dispatch('logIn', userData);
                        router.push('/');
                    })
                    .catch(function (error) {
                       if(error.data.err && error.data.err.type === 'passStrength') {
                           this.user.passValid = false;
                           this.alertData = {
                               type: error.data.type,
                               msg: error.data.err.msg,
                           };
                       } else if (error.data.err && error.data.err.type === 'locked') {
                           this.alertData = {
                               type: error.data.type,
                               msg: error.data.err.msg + ' ' + error.data.err.locked,
                           };
                       } else {
                           this.alertData = {
                               type: error.data.type,
                               msg: error.data.msg
                           };
                       }
                        mainEventBus.$emit('alert', this.alertData);
                        /*this.lblLoginFailed = error.data.title;
                        this.showAlertWarning = true;*/
                    });
            },
            closeAlertNoInput: function(){
                this.showFormWarning = false;
            },
            closeAlertWarning: function(){
                this.showAlertWarning = false;
            }
        }
    }
</script>

<style scoped>
    body {
        /*background: #2d0506 url("/static/bck_01.jpg") no-repeat fixed center;*/
    }
    .alert-warning {
        margin-top: 10px !important;
    }

    .vue-toast-manager_container.\--top {
        top: 0;
    }
</style>


// WEBPACK FOOTER //
// Login.vue?23dd8712